import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import { Flex } from '../UI/Flex/Flex';
import { Tab, Tabs } from 'react-bootstrap';
import EditEvalComponent from './EditEvalsComponent';
interface ModalEditEvalsProps {
    taskId: string;
}
export const ModalEditEvals = observer((props: ModalEditEvalsProps) => {
    enum EvalGroups {
        GLOBAL = 'global',
        TASK = 'task'
    }
    return (
        <Flex fillCell={true} direction="column">
            <Tabs defaultActiveKey={EvalGroups.GLOBAL}>
                <Tab
                    eventKey={EvalGroups.GLOBAL}
                    title="Global"
                    // className={style.container}
                >
                    <EditEvalComponent realtime_path="/flowtasks/evals" />
                </Tab>
                <Tab
                    eventKey={EvalGroups.TASK}
                    title="Task"
                    // className={style.container}
                >
                    <EditEvalComponent
                        realtime_path={`/flowtasks/defs/${props.taskId}/evals`}
                    />
                </Tab>
            </Tabs>
        </Flex>
    );
});
